import Hero from "../components/aboutPage/hero/Hero";
import Why from "../components/aboutPage/why/Why";
import Mission from "../components/aboutPage/Mission/Mission";
import useSetTags from "../hooks/useSetTags";

const CONFIG = {
  sl: {
    title: "Metoda in ideja v ozadju tečajev",
    description: "Izvedite vse o eLingu: metoda učenja in prednosti tečajev. Pridružite se eLingu in izkoristite prednosti! Resnični rezultati v kratkem času.",
  }
}

const AboutPage = ({ data }) => {

  useSetTags(CONFIG);

  return (
    <>
      <Hero data={data.hero} />
      <Why data={data.why} />
      <Mission data={data.mission} />
    </>
  );
};

export default AboutPage;
